export async function getTitleDescriptionAndImage(url) {
  try {
    const urlParts = new URL(url);
    if (
      !urlParts.hostname.includes("youtube.com") &&
      !urlParts.hostname.includes("youtu.be")
    ) {
      throw new Error("Invalid YouTube URL");
    }

    const videoId = getVideoId(url);
    if (!videoId) return {};

    const bestUrl = await getBestYouTubeThumbnail(videoId);
    if (bestUrl) return { image: bestUrl };

    return {};
  } catch {
    return {};
  }
}

function getVideoId(url) {
  try {
    const urlParts = new URL(url);

    if (
      !urlParts.hostname.includes("youtube.com") &&
      !urlParts.hostname.includes("youtu.be")
    ) {
      throw new Error("Invalid YouTube URL");
    }

    if (urlParts.hostname === "youtu.be") {
      return urlParts.pathname.slice(1);
    }

    if (urlParts.pathname.startsWith("/watch") && urlParts.searchParams.has("v")) {
      return urlParts.searchParams.get("v");
    }

    if (urlParts.pathname.startsWith("/embed/") || urlParts.pathname.startsWith("/shorts/") || urlParts.pathname.startsWith("/live/")) {
      return urlParts.pathname.split("/")[2];
    }

    throw new Error("No valid video ID found");
  } catch {
    return null;
  }
}

async function getBestYouTubeThumbnail(videoId) {
  const sizes = [
    "maxresdefault",
    "sddefault",
    "hqdefault",
    "mqdefault",
    "default",
  ];

  for (const size of sizes) {
    const url = `https://img.youtube.com/vi/${videoId}/${size}.jpg`;
    const ok = await checkImage200(url);
    if (ok) return url;
  }

  return null;
}

async function checkImage200(url) {
  try {
    const res = await fetch(url, { method: "HEAD" });
    return res.ok; // true only for 2xx
  } catch {
    return false;
  }
}
